module.exports = __webpack_public_path__ + "img/icon-open.1b76a298.svg";